import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../UserContext";
import axios from "axios";
import "./Tasks.css";
import toast from "react-hot-toast"; // Add this line

const TaskListSelector = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { fieldId } = useParams();
  const location = useLocation();
  const { userData, token } = useContext(UserContext);

  // The path to return to after selection, passed from the TaskForm
  const returnTo = location.state?.returnTo || `/fields/${fieldId}`;
  const [taskLists, setTaskLists] = useState([]); // Initialize with empty array
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    //   // Mock Data - In a real app, you'd fetch this via API: GET /api/taskList/findByFarmId/{farmId}
    //   const [taskLists, setTaskLists] = useState([
    //     { id: 1, name: "مهام المزرعة", fromDate: "2025-08-12", toDate: "2025-08-20" },
    //     { id: 2, name: "planned task list", fromDate: "2025-06-19", toDate: "2025-10-31" },
    //     { id: 3, name: "شروق", fromDate: "2024-11-14", toDate: "2024-12-11" },
    //   ]);
    const fetchTaskLists = async () => {
      if (!userData?.Farm?.id || !token) {
        setLoading(false);
        return;
      }
      try {
        // API Call: GET /api/taskList/findByFarmId/{farmId}
        const response = await axios.get(
          `api/taskList/findByFarmId/${userData.Farm.id}`,
          {
            headers: { Authorization: token },
          }
        );
        setTaskLists(response.data.items.map((item) => item.taskList) || []);
      } catch (error) {
        console.error("Failed to fetch task lists:", error);
        toast.error(t("Could not load task lists."));
      } finally {
        setLoading(false);
      }
    };
    fetchTaskLists();
  }, [userData, token, t]);

  const handleSelect = (listId) => {
    // Navigate back to the form, passing the selected ID in the state
    navigate(returnTo, {
      state: {
        ...location.state,
        selectedTaskListId: listId,
      },
    });
  };

  const handleAddNew = () => {
    // Navigate to the form for creating a new list
    navigate(`/fields/${fieldId}/tasklists/new`, {
      state: { ...location.state, returnTo: returnTo },
    });
  };

  return (
    <div className="task-list-page-container">
      {loading ? (
        // Show this while fetching
        <div className="loading">{t("Loading...")}</div>
      ) : (
        <>
          <header className="view-header">
            <h1 className="view-header-title-group">{t("Task Lists")}</h1>
          </header>
          <div className="task-list-selector-body">
            {taskLists.length === 0 ? (
              <p>{t("No task lists found.")}</p>
            ) : (
              taskLists.map((list) => (
                <div
                  key={list.id}
                  className="task-list-item"
                  onClick={() => handleSelect(list.id)}
                >
                  <div className="task-list-item-info">
                    <h4>{list.name}</h4>
                    {list.note && (
                      <p className="task-list-note">{list.note}</p>
                    )}
                    <p>
                      {list.fromDate && list.toDate
                        ? `${new Date(list.fromDate).toLocaleDateString(
                            "en-GB"
                          )} ${t("To")} ${new Date(
                            list.toDate
                          ).toLocaleDateString("en-GB")}`
                        : t("No dates available")}
                    </p>
                  </div>
                </div>
              ))
            )}
          </div>
          <footer className="task-list-page-footer">
            <button
              className="button-primary button-full-width"
              onClick={handleAddNew}
            >
              {t("Add Task List")}
            </button>
          </footer>
        </>
      )}
    </div>
  );
};

export default TaskListSelector;
